import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "antd/dist/antd.dark.css";
import LoginLayoutRoute from "./layouts/LoginLayoutRoute";
import AppLayoutRoute from "./layouts/AppLayoutRoute";
import "./App.css";
import { Homes } from "pages/home/Index";
import WarehouseDashboard from "pages/warehouse-dashboard/WarehouseDashboard";
import Login from "pages/login/Index";
import { Companies } from "pages/companies/Index";
import { People } from "pages/people/Index";
import { Roles } from "pages/roles/Index";
import { StockClassifications } from "pages/stock-classifications/Index";
import { PackingTypes } from "pages/packing-types/Index";
import { MeasurementTypes } from "pages/measurement-types/Index";
import { Bins } from "pages/bins/Index";
import { BinLocations } from "pages/bin-locations/Index";
import { LotNumbers } from "pages/lotnumbers/Index";
import { MaterialTypes } from "pages/material-types/Index";
import { MaterialDetails } from "pages/material-details/Index";
import { MaterialRequests } from "pages/material-requests/Index";
import { StockReceipts } from "pages/stock-receipts/Index";
import { StockReceipt } from "pages/stock-receipt/Index";
import { StockIssue } from "pages/stock-issue/Index";
import { Stores } from "pages/stores/Index";
import { Reports } from "pages/reports/Index";
import { Account } from "pages/account/Index";
import { StockTransfer } from "pages/stock-transfer/Index";
import { StockCount } from "pages/stock-count/Index";
import { StockCheck } from "pages/stock-check/Index";
import { Suppliers } from "pages/suppliers/Index";
import { Departments } from "pages/departments/Index";
import { Machines } from "pages/machines/Index";
import { Vehicles } from "pages/vehicles/Index";
import { Sbu } from "pages/sbu/Index";
import { Zones } from "pages/zones/Index";
import { SubLocations } from "pages/sub-locations/Index";
import { Jobs } from "pages/jobs/Index";
import { EquipmentTypes } from "pages/equipment-types/Index";
import { Equipments } from "pages/equipments/Index";
import { WorkItems } from "pages/work-items/Index";
import { Tasks } from "pages/tasks/Index";
import { PurchaseOrders } from "pages/purchase-orders";
import { Employee } from "pages/employee";
import { Bom } from "pages/bom/Index";
import { Racks } from "pages/racks";
import { CompanyCategories } from "pages/company-categories";
import { Reason } from "pages/reason/Index";
import { Gurantees } from "pages/gurantee/Index";
import { CreditVouchers } from "pages/credit-vouchers/Index";
import { TaxLines, TaxTypes } from "pages/tax-types/Index";
import { References } from "pages/references/Index";
import Store3DView from "pages/warehouse-dashboard/Store3DView";
import * as THREE from "three";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import TestWarehouse2DView from "./pages/warehouse-dashboard/storeview2d";
import Warehouse2DViewSwitcher from "./pages/warehouse-dashboard/Warehouse2DViewSwitcher";
import PDFEditorWithDrawing from "pages/documents/test-pdf-view-edit";
import { Documents } from "pages/documents";
import { StockDelete } from "pages/stock-delete";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          <Redirect to="/dashboard" />
        </Route>

        <LoginLayoutRoute path="/login" component={Login} />

        <AppLayoutRoute path="/dashboard" component={Homes} />
        <AppLayoutRoute
          path="/warehouse-dashboard"
          component={WarehouseDashboard}
        />
        <AppLayoutRoute path="/warehouse-3d-view" component={Store3DView} />
        <AppLayoutRoute
          path="/test-warehouse-2d"
          component={TestWarehouse2DView}
        />
        <AppLayoutRoute
          path="/warehouse-2d"
          component={Warehouse2DViewSwitcher}
        />
        <AppLayoutRoute path="/companies" component={Companies} />
        <AppLayoutRoute path="/people" component={People} />
        <AppLayoutRoute path="/roles" component={Roles} />
        <AppLayoutRoute path="/suppliers" component={Suppliers} />
        <AppLayoutRoute path="/departments" component={Departments} />
        <AppLayoutRoute path="/machines" component={Machines} />
        <AppLayoutRoute path="/vehicles" component={Vehicles} />
        <AppLayoutRoute path="/sbu" component={Sbu} />
        <AppLayoutRoute path="/zones" component={Zones} />
        <AppLayoutRoute path="/sub-locations" component={SubLocations} />
        <AppLayoutRoute
          path="/stock-classifications"
          component={StockClassifications}
        />
        <AppLayoutRoute path="/packing-types" component={PackingTypes} />
        <AppLayoutRoute
          path="/measurement-types"
          component={MeasurementTypes}
        />
        <AppLayoutRoute path="/bins" component={Bins} />
        <AppLayoutRoute path="/bin-locations" component={BinLocations} />
        <AppLayoutRoute path="/lotnumbers" component={LotNumbers} />
        <AppLayoutRoute path="/material-types" component={MaterialTypes} />
        <AppLayoutRoute path="/material-details" component={MaterialDetails} />
        <AppLayoutRoute
          path="/material-requests"
          component={MaterialRequests}
        />
        <AppLayoutRoute path="/stock-receipts" component={StockReceipts} />
        <AppLayoutRoute path="/stock-receipt/:id" component={StockReceipt} />
        <AppLayoutRoute path="/stock-issue" component={StockIssue} />
        {/* <AppLayoutRoute path="/stores" component={Stores} /> */}
        <AppLayoutRoute path="/stores" component={Warehouse2DViewSwitcher} />
        <AppLayoutRoute path="/stock-transfer" component={StockTransfer} />
        <AppLayoutRoute path="/stock-count" component={StockCount} />
        <AppLayoutRoute path="/stock-check" component={StockCheck} />
        <AppLayoutRoute path="/reports" component={Reports} />

        <AppLayoutRoute path="/account" component={Account} />
        <AppLayoutRoute path="/jobs" component={Jobs} />
        <AppLayoutRoute path="/equipment-types" component={EquipmentTypes} />
        <AppLayoutRoute path="/equipments" component={Equipments} />
        <AppLayoutRoute path="/work-items" component={WorkItems} />
        <AppLayoutRoute path="/tasks" component={Tasks} />

        <AppLayoutRoute path="/purchase-orders" component={PurchaseOrders} />
        <AppLayoutRoute path="/employee" component={Employee} />
        <AppLayoutRoute path="/bom" component={Bom} />
        <AppLayoutRoute path="/racks" component={Racks} />
        <AppLayoutRoute
          path="/company-categories"
          component={CompanyCategories}
        />
        <AppLayoutRoute path="/reasons" component={Reason} />
        <AppLayoutRoute path="/gurantees" component={Gurantees} />
        <AppLayoutRoute path="/credit-vouchers" component={CreditVouchers} />
        <AppLayoutRoute path="/tax-types" component={TaxTypes} />
        <AppLayoutRoute path="/references" component={References} />
        <AppLayoutRoute
          path="/documents"
          // component={PDFEditorWithDrawing}
          component={Documents}
        />
        <AppLayoutRoute path="/stock-delete" component={StockDelete} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
